var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "End call"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"translate\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.449 8.87305H12.6809C10.7342 8.87305 9.77051 9.84695 9.77051 11.8142V15.6319C9.77051 17.6381 10.7342 18.612 12.6809 18.5633H16.4586C18.4438 18.612 19.4075 17.6381 19.3593 15.6222V11.8142C19.4075 9.84695 18.4438 8.87305 16.449 8.87305ZM16.526 16.4305C15.8707 16.4305 15.2347 16.1773 14.7047 15.7293C14.1072 16.1675 13.3844 16.4305 12.6038 16.4305C12.2087 16.4305 11.881 16.0994 11.881 15.7001C11.881 15.3008 12.2087 14.9697 12.6038 14.9697C13.5868 14.9697 14.4059 14.2879 14.7047 13.353H12.6038C12.2087 13.353 11.881 13.0219 11.881 12.6226C11.881 12.2233 12.2087 11.8921 12.6038 11.8921H13.847C13.8855 11.5221 14.1843 11.2299 14.5601 11.2299C14.9359 11.2299 15.2347 11.5221 15.2732 11.8921H15.5238H15.5431H15.5623H16.5164C16.9115 11.8921 17.2392 12.2233 17.2392 12.6226C17.2392 13.0219 16.9212 13.353 16.5164 13.353H16.1984C16.1117 13.8205 15.9286 14.2587 15.6876 14.658C15.9478 14.8528 16.2273 14.9697 16.526 14.9697C16.9212 14.9697 17.2488 15.3008 17.2488 15.7001C17.2488 16.0994 16.9212 16.4305 16.526 16.4305Z",
    fill: "#730BDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5165 29.0809C12.4015 29.0809 9.04785 25.6917 9.04785 21.5332C9.04785 21.1339 9.37551 20.8027 9.77063 20.8027C10.1657 20.8027 10.4934 21.1339 10.4934 21.5332C10.4934 24.4159 12.4786 26.8312 15.1481 27.4642L14.8879 27.0259C14.6855 26.6753 14.7915 26.2273 15.1384 26.0228C15.4757 25.8183 15.9287 25.9254 16.131 26.276L17.1429 27.9804C17.2779 28.2044 17.2779 28.4868 17.1526 28.7108C17.0177 28.9348 16.7767 29.0809 16.5165 29.0809Z",
    fill: "#730BDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.0441 16.4207C28.649 16.4207 28.3213 16.0896 28.3213 15.6903C28.3213 12.8076 26.3361 10.3923 23.6666 9.75925L23.9268 10.1975C24.1292 10.5481 24.0232 10.9961 23.6763 11.2006C23.339 11.4051 22.886 11.298 22.6836 10.9474L21.6718 9.24308C21.5368 9.01909 21.5368 8.73666 21.6621 8.51266C21.797 8.28866 22.038 8.14258 22.2982 8.14258C26.4132 8.14258 29.7668 11.5317 29.7668 15.6903C29.7668 16.0896 29.4392 16.4207 29.0441 16.4207Z",
    fill: "#730BDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.1476 18.4678C21.4492 18.4678 19.252 20.6785 19.252 23.4152C19.252 26.1421 21.4396 28.3626 24.1476 28.3626C26.8459 28.3626 29.0431 26.1518 29.0431 23.4152C29.0431 20.6785 26.8555 18.4678 24.1476 18.4678ZM26.5375 25.7623C26.181 25.9376 25.7473 25.8012 25.5642 25.4311L25.4004 25.1H22.9044L22.7405 25.4311C22.6153 25.6844 22.3551 25.8304 22.0949 25.8304C21.9889 25.8304 21.8732 25.8012 21.7768 25.7525C21.4203 25.5675 21.2757 25.1292 21.4492 24.7689L23.5115 20.6104C23.6368 20.3669 23.8874 20.2111 24.1572 20.2111C24.427 20.2111 24.6776 20.3669 24.8029 20.6201L26.8652 24.7786C27.0387 25.139 26.8941 25.5772 26.5375 25.7623Z",
    fill: "#730BDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.627 23.6377H24.6774L24.1474 22.5762L23.627 23.6377Z",
    fill: "#730BDB"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.975c60edb4939d8531185c554bfab8c9.svg";
export { ForwardRef as ReactComponent };